import { API, ensureCsrfToken } from "./api";

export async function openChatStream(payload) {
  const csrfToken = await ensureCsrfToken();

  const response = await fetch(`${API}/chat`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok || !response.body) {
    throw new Error("Chat request failed");
  }

  return response;
}
